export default "/_next/static/images/mariana-alves-1a5c6a2162c879fcb08752522d0a8fb4.png";